// extracted by mini-css-extract-plugin
module.exports = {"projectWrapper":"projects-module--project-wrapper--2CmNW"};